export default __webpack_public_path__ + "assets/fae89f44343c6e601b395219aacc399a.png";